exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".background {\n    background-color: steelblue;\n    width:100%;\n    height: 100%;\n}\n\n.text-centre {\n    text-align: center;\n}\n\n.title {\n    font-size: x-large;\n    height: 20px;\n    padding-top: 10px;\n}\n\n.modal-body {\n    font-size: 10pt;\n    word-wrap: normal;\n}\n\n.modal-footer {\n    text-align: right;\n}\n\nh5 {\n    font-size: medium;\n    font-weight: bold;\n    font-style: italic;\n    color: #007eb3;\n    padding: 0px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/DateModal/dateModal.component.css
// module id = 443
// module chunks = 1